// extracted by mini-css-extract-plugin
export var childrenContainer = "_ax-0";
export var virtualScrollArea = "_ax-1";